



























import Vue from 'vue'
import SearchControl from '@/top/components/SearchControl.vue'
import HistoryProduct from '@/top/components/HistoryProduct.vue'
import TopPageArticle from '@/top/components/TopPageArticle.vue'
import BrandsProduct from '@/top/components/BrandsProduct.vue'
import TopPageNotice from '@/top/components/TopPageNotice.vue'

import { Article, TopProducts, TopProductItem } from '@/top/types'
import { MaxQuantityPrice } from '@/common/types/maxQuantityPrice'
import { Announcement } from '@/common/types/announcements'

export default Vue.extend({
  name: 'TopPageMain',
  components: {
    SearchControl,
    HistoryProduct,
    TopPageArticle,
    BrandsProduct,
    TopPageNotice
  },
  props: {
    productCategories: {
      type: Array,
      required: true
    },
    articlesData: {
      type: Array as () => Article[],
      required: true
    },
    announcementsData: {
      type: Array as () => Announcement[],
      required: true
    },
    maxQuantityPrice: {
      type: Object as () => MaxQuantityPrice,
      required: true
    },
    flagTopSearch: {
      type: Boolean,
      required: true
    },
    historyProducts: {
      type: Array as () => TopProductItem[],
      required: true
    },
    topProducts: {
      type: Array as () => TopProducts[],
      required: true
    }
  },
  computed: {
    noticeInfo(): Announcement[] {
      return this.announcementsData.filter(item => {
        return item.announcement_type === 'info'
      })
    }
  }
})
